import React, { useState, FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectorCurrentDealIsLoading } from "src/redux/currentDeal/selector";
import { createDealFromInquiryAsync } from "src/redux/currentDeal/actions";
import {
  addToWatchlistAsync,
  removeFromWatchlistAsync,
} from "src/redux/watchlist/actions";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as MessageIcon } from "src/assets/icons/message.svg";
import { ReactComponent as EyeIcon } from "src/assets/icons/eye.svg";
import { inquiryItemTrns } from "./trns";

const DEFAULT_ACTION_BUTTON_CLASSNAME =
  "flex gap-2 items-center justify-center h-10 font-medium";

interface Props {
  id: number;
  isFavorite: boolean;
  isHost: boolean;
  isActiveDeal: boolean;
  setIsFavorite: (isFavorite: boolean) => void;
}

export const ActionButtons: FC<Props> = ({
  id,
  isFavorite,
  isHost,
  isActiveDeal,
  setIsFavorite,
}) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const isLoadingDeal = useAppSelector(selectorCurrentDealIsLoading);

  const [isLoadingWatchlist, setIsLoadingWatchlist] = useState(false);

  const createDeal = () => {
    dispatch(createDealFromInquiryAsync(id));
  };

  const onSuccessAddToWatchlist = () => {
    setIsFavorite(true);
    setIsLoadingWatchlist(false);
  };

  const onSuccessRemoveFromWatchlist = () => {
    setIsFavorite(false);
    setIsLoadingWatchlist(false);
  };

  const addToWatchlist = () => {
    setIsLoadingWatchlist(true);
    dispatch(addToWatchlistAsync({ id, onSuccess: onSuccessAddToWatchlist }));
  };

  const removeFromWatchlist = () => {
    setIsLoadingWatchlist(true);
    dispatch(
      removeFromWatchlistAsync({ id, onSuccess: onSuccessRemoveFromWatchlist })
    );
  };

  const handleAddToFavoriteButton = () => {
    if (isFavorite) {
      removeFromWatchlist();
    } else {
      addToWatchlist();
    }
  };

  const isDisabledDealBtn = isLoadingDeal || isHost || isActiveDeal;

  const labelFavoriteBtn = isFavorite
    ? inquiryItemTrns.removeFromWatchlistButton
    : inquiryItemTrns.addToWatchlistButton;

  return (
    <div className="flex flex-col gap-3">
      <Button
        className={DEFAULT_ACTION_BUTTON_CLASSNAME}
        variant={ButtonVariants.PRIMARY}
        onClick={createDeal}
        isLoading={isLoadingDeal}
        isDisabled={isDisabledDealBtn}
      >
        <MessageIcon className="w-6 h-6 fill-svg-white-base" />
        <span>{t(inquiryItemTrns.startDealButton)}</span>
      </Button>

      <Button
        className={DEFAULT_ACTION_BUTTON_CLASSNAME}
        variant={ButtonVariants.SECONDARY}
        onClick={handleAddToFavoriteButton}
        isLoading={isLoadingWatchlist}
        isDisabled={isLoadingWatchlist}
      >
        <EyeIcon />
        <span>{t(labelFavoriteBtn)}</span>
      </Button>
    </div>
  );
};
